// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"565":"component---src-templates-page-js","835":"Autocomplete","969":"component---src-templates-tag-js"}[chunkId] || chunkId) + "-" + {"565":"fcf89725e03c608d5ad0","835":"57c8a3d155dd7176ddfd","954":"c37e18493cfef4f307d3","969":"aa39d0700778ae82df2f"}[chunkId] + ".js";
};